import OurVision from './our-vision';

export default OurVision;
